import { Component } from "react";
import axios from "axios";
import { setItemToStore } from "@helpers/utils";
// ** ThemeConfig
import themeConfig from "@configs/theme-config";

class ErrorBoundary extends Component {
    constructor (props) {
        super(props);
        this.state = {
            hasError      : false,
            chunkLoadError: false
        };
    }

    componentDidCatch (error, info) {
        if (
            error?.message?.includes("Failed to fetch dynamically imported module")
        ) {
            // Force a reload when a chunk fails to load
            this.setState({ chunkLoadError: true });
        }
        this.setState({ error, info, hasError: true });
    }

    render () {
        const { hasError, chunkLoadError } = this.state;
        const { children } = this.props;
        const {
            app: { logo }
        } = themeConfig;

        const updateAppVersion = async () => {
            const response =  await axios.get(`/dist/version.txt?${Date.now()}`);
            const currentVersion = new Date(response.headers?.["last-modified"]).valueOf();
            setItemToStore("appVersion", currentVersion);
            window.location.reload();
        };

        const handleErrorClick = () => {
            window.location.href = "/";
        };
        
        return hasError ? (
            <div className="flex min-h-screen flex-col items-center justify-center text-center p-4">
                {window.navigator.onLine && (
                    <span className="mb-6 flex items-center justify-center gap-2.5">
                        <img className="h-10 w-10 rounded-xl object-cover" src={logo} alt="NookPay" id="brand-logo" />
                        <span className="text-lg font-semibold tracking-tight text-gray-900">NookPay</span>
                    </span>
                )}
                <div className="relative max-w-[750px] p-6 sm:p-12 text-center">
                    <h4 className="mt-6">
                        {/* {error} */}
                        {chunkLoadError ? (
                            <>
                                {" "}
                                A new version of product is available. Please click on &apos;Refresh&apos; to apply the changes.
                            </>
                        ) : (
                            <>
                                Try refreshing the page, or going back and attempting the action again. If this problem persists,contact us.
                            </>
                        )}
                    </h4>

                    <div className="mt-6 flex align-center justify-center gap-4">
                        <button
                            type="button"
                            onClick={() => handleErrorClick()}
                            className="w-full rounded border border-secondary px-4 py-2 text-sm font-medium text-secondary hover:bg-secondary/10 sm:w-auto">
                                Back to home
                        </button>
                        <button
                            type="button"
                            onClick={() => updateAppVersion()}
                            className="w-full rounded bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90 sm:w-auto">
                            {chunkLoadError ? "Refresh" : "Try Again !"}
                        </button>
                    </div>

                </div>
            </div>
        ) : (
            children
        );
    }
}

export default ErrorBoundary;
